// const propertySettings = {
//   sec_user_perms: "has_secondary_user_permissions_enabled",
//   user_access_groups: "has_user_access_groups_permissions_enabled",
//   security_guard_transactions:
//     "has_security_guard_transactions_permissions_enabled",
//   schedule_restrictions: "has_schedule_restrictions",
// } as const;

// export default propertySettings;

// export type PropertySettingKey = keyof typeof propertySettings;

// utils/propertySettings.ts
export const propertySettings = {
    sec_user_perms: "has_secondary_user_permissions_enabled",
    user_access_groups: "has_user_access_groups_permissions_enabled",
    security_guard_transactions: "has_security_guard_transactions_permissions_enabled",
    schedule_restrictions: "has_schedule_restrictions",
    requirements_permission: "has_requirements_permission",
    printable_pass: "has_printable_pass_function"
  } as const;
  
  export type PropertySettingKey = keyof typeof propertySettings;
  
  export const propertySettingsDefaults: Record<PropertySettingKey, boolean> = {
    sec_user_perms: true,               // ejemplo: default true
    user_access_groups: false,           // default false
    security_guard_transactions: true, // default true
    schedule_restrictions: false,       // default false; show exit UI only when property sets true
    requirements_permission: false,      // default false
    printable_pass: false,               // default false
  };
